import React, { useContext, useState, useEffect, useRef } from "react";
import { useParams } from "react-router";
import { Box, Paper } from "@material-ui/core";
import { format } from "react-string-format";
import MaterialTable from "material-table";
import { Context } from "../../../utils/context";
import { Strings } from "../../../assets/res/en";
import useCommonMenus from "../common/useCommonMenus";
import useStyles from "../../useStyles";
import addressDataColumn from "../../../dataColumns/addressDataColumn";
import telephonesDataColumn from "../../../dataColumns/telephonesDataColumn";
import emailsDataColumn from "../../../dataColumns/emailsDataColumn";
import cardholderDataColumn from "../../../dataColumns/cardholderDataColumn";
import {
  Group,
  LocationOn,
  Grain
} from "@material-ui/icons";
import {
  cardholdersEndPoints,
  merchantsEndPoints,
  groupsEndPoints,
} from "../../../utils/endpoints";
import { addDays, modules, config } from "../../../utils/config";
import { useHistory } from "react-router-dom";
let isODEndDateTimeDisabled = true,
  ODMinEndDateTime = null,
  isCDEndDateTimeDisabled = true,
  CDMinEndDateTime = null;
function useCardholdersDetails() {
  const { axios, authData, permissions } = useContext(Context);
  const authToken = `Bearer ${authData.token}`;
  const tableRefOpen = useRef();
  const tableRefClosed = useRef();
  const classes = useStyles();
  const [cardHolderPermission, setCardHolderPermission] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(true);
  const [balanceLoading, setBalanceLoading] = useState(true);
  const [generalLoading, setGeneralLoading] = useState(true);
  const [details, setDetails] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [modalHeader, setModalHeader] = useState({});
  const [modalContent, setModalContent] = useState({});
  const [modalFormResetKeys, setModalFormResetKeys] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [telephoneData, setTelephoneData] = useState([]);
  const [emailData, setEmailData] = useState([]);
  const [openBalance, setOpenBalance] = useState([]);
  const [closedBalance, setClosedBalance] = useState([]);
  const [statusAPIres, setStatusAPIRes] = useState({});
  const [value, setValue] = useState(0);
  const [TranscationTabIndex, setTranscationTabIndex] = useState(0);
  const [snak_open, setSnackOpen] = useState(false);
  const [cardType, setCardType] = useState([]);
  const [allCardData, setCards] = useState([]);

  const [cardProgramDescription, setCardProgramDescription] = useState();
  const [cardGroupDescription, setCardGroupDescription] = useState();
  const [cardMerchantDescription, setCardMerchantDescription] = useState();
  const [cardNumberDescription, setCardNumberDescription] = useState();
  const [cardId, setCardId] = useState(0);
  const [cardRealIndex, setCardRealIndex] = useState(0);
  const [cardInfo, setCardInfo] = useState();
  const [device_log, setDeviceLog] = useState({})
  const [current_transactions, setCurrentTransactions] = useState([])
  const [total_transactions, setTotalTransactions] = useState(1)
  const {
    transcationOpenColumns,
    transcationCloseColumns,
    transStylingOption,
    transcationColumnsOBInner,
    transcationColumnsCBInner,
  } = cardholderDataColumn(classes);
  const { telephone, email, address, dob, driversLicense } = details;

  const { telephoneTypeMenus, addressTypeMenus, countryMenus, stateMenus } =
    useCommonMenus(axios);
  const { addressCols } = addressDataColumn(
    addressTypeMenus,
    countryMenus,
    stateMenus
  );
  const { teleCols } = telephonesDataColumn(telephoneTypeMenus);
  const { emailCols } = emailsDataColumn();
  const { id } = useParams();
  const cardBasicDetails = [
    { title: Strings.TELEPHONE, value: telephone },
    { title: Strings.EMAIL, value: email },
    { title: Strings.ADDRESS, value: address },
    { title: Strings.DATEOFBIRTH, value: dob },
    { title: Strings.DRIVERSLICENSE, value: driversLicense },
  ];
  const [openSearchData, setOpenSearchData] = useState({
    sFromDate: null,
    sToDate: null,
    sType: "",
  });
  const [closedSearchData, setClosedSearchData] = useState({
    sFromDate: null,
    sToDate: null,
    sType: "",
  });
  const tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
  const dateNow = new Date();
  const firstDay = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1);
  const firstDateNTime = new Date(firstDay - tzoffset)
    .toISOString()
    .slice(0, -1);
  const lastDay = new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 0);
  const endOfDayDate = new Date(
    lastDay.getFullYear(),
    lastDay.getMonth(),
    lastDay.getDate(),
    23,
    59,
    59
  );
  const lastDateNTime = new Date(endOfDayDate - tzoffset)
    .toISOString()
    .slice(0, -1);
  const realDetails = [
    {
      title: Strings.GROUP,
      value: cardInfo ? cardInfo.groupDescription : '-',
      icon: <Group />,
      classDetail: `${classes.groupButton} ${classes.chBtn}`,
    },
    {
      title: Strings.LOCATION,
      value: cardInfo ? cardInfo.merchantDescription : '-',
      icon: <LocationOn />,
      classDetail: `${classes.themedButton} ${classes.chBtn}`,
    },
    {
      title: Strings.PROGRAM,
      value: cardInfo ? cardInfo.program : '-',
      icon: <Grain />,
      classDetail: `${classes.programButton} ${classes.chBtn}`,
    },
    {
      title: Strings.CARD,
      value: cardInfo ? cardInfo.lastEightDigits : '-',
      icon: <Grain />,
      classDetail: `${classes.cardnumberButton} ${classes.chBtn}`,
    },
    
    
  ];
  //check permission changes
  useEffect(() => {
    if (permissions && permissions.length > 0) {
      let chPermission = permissions.find(
        (p) => p.moduleId === modules.cardholders.id
      );
      setCardHolderPermission(chPermission);
    }
  }, [permissions]);

  /*useEffect(() => {
    if (cardHolderPermission && cardHolderPermission.read === true) {
      getLastStartup();
      getDetails();
      if (cardId > 0) {
        getOpenCardBalance();
        getClosedCardBalance();
        getCardInfoByCardId();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardId, cardHolderPermission]);*/

  useEffect(() => {
    const initModule = async() => {
      setGeneralLoading(true)
      try {
        await getLastStartup()
        await getDetails()
        if (cardId > 0) {
          setBalanceLoading(true)
          try {
            await getOpenCardBalance();
            await getClosedCardBalance();
            await getCardInfoByCardId();
          } catch (error) {
            console.log(error)
          }
          setBalanceLoading(false)
          
        }
      } catch (error) {
        console.log(error)
      }
      setGeneralLoading(false)
    }
    if (cardHolderPermission && cardHolderPermission.read === true) initModule()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardId, cardHolderPermission]);

  //get address, telephones and emails on More button click
  useEffect(() => {
    new Promise((resolve) => {
      setModalFormResetKeys(["address", "telephones", "emails"]);
      resolve();
    }).then(() =>
      setModalContent((prevContent) => ({
        ...prevContent,
        address: {
          ...prevContent["address"],
          data: addressData,
        },
        telephones: {
          ...prevContent["telephones"],
          data: telephoneData,
        },
        emails: {
          ...prevContent["emails"],
          data: emailData,
        },
      }))
    );
  }, [addressData, telephoneData, emailData]);

  const handleOpenSearch = () => {
    const fromDate = openSearchData["sFromDate"] ?? firstDateNTime;
    const openFromDateTime = openSearchData["sFromDate"]
      ? new Date(openSearchData["sFromDate"] - tzoffset)
        .toISOString()
        .slice(0, -1)
      : firstDateNTime;
    var openToDate = openSearchData["sFromDate"]
      ? openSearchData["sToDate"]
        ? openSearchData["sToDate"]
        : addDays(fromDate, 7)
      : endOfDayDate;
    const openToDateTime = new Date(openToDate - tzoffset)
      .toISOString()
      .slice(0, -1);
    if (
      openSearchData["sFromDate"] != null &&
      openSearchData["sToDate"] === null
    ) {
      setOpenSearchData((prevData) => ({
        ...prevData,
        sToDate: new Date(openToDateTime),
      }));
    }

    let params = {
      transTypes: openSearchData["sType"],
      affectsOpenLoop: 0,
      onlyGatherOpenLoopAffectationsInDetails: false,
      affectsCloseLoop: 1,
      onlyGatherCloseLoopAffectationsInDetails: true,
      idCardholder: id,
      fromDate: openFromDateTime,
      toDate: openToDateTime,
    };
    tableRefOpen.current.onQueryChange(params);
  };
  const handleClosedSearch = () => {
    const fromDate = closedSearchData["sFromDate"] ?? firstDateNTime;
    const closedFromDateTime = closedSearchData["sFromDate"]
      ? new Date(closedSearchData["sFromDate"] - tzoffset)
        .toISOString()
        .slice(0, -1)
      : firstDateNTime;
    var closedToDate = closedSearchData["sFromDate"]
      ? closedSearchData["sToDate"]
        ? closedSearchData["sToDate"]
        : addDays(fromDate, 7)
      : endOfDayDate;
    const closedToDateTime = new Date(closedToDate - tzoffset)
      .toISOString()
      .slice(0, -1);
    if (
      closedSearchData["sFromDate"] != null &&
      closedSearchData["sToDate"] === null
    ) {
      setClosedSearchData((prevData) => ({
        ...prevData,
        sToDate: new Date(closedToDateTime),
      }));
    }

    let params = {
      transTypes: closedSearchData["sType"],
      affectsOpenLoop: 1,
      onlyGatherOpenLoopAffectationsInDetails: true,
      affectsCloseLoop: 0,
      onlyGatherCloseLoopAffectationsInDetails: false,
      idCardholder: id,
      fromDate: closedFromDateTime,
      toDate: closedToDateTime,
    };
    tableRefClosed.current.onQueryChange(params);
  };

  const getAllCardsOfCurrentCardholder = () => {
    new Promise((resolve, reject) => {
      let url = format(cardholdersEndPoints.allCardHolderById, id);
      axios
        .get(url, {
          headers: { Authorization: authToken },
        })
        .then((res) => {
          if (res.data.success) {
            const { cards } = res.data.data;
            setCards(cards);
            setActiveCardRealDetail();
            onRealChange()
            resolve();
          }
        })
        .catch((err) => { });
    });
  };

  const handleODChange = (name, value) => {
    if (name === "sFromDate") {
      ODMinEndDateTime = value;
      isODEndDateTimeDisabled = value ? false : true;
      setOpenSearchData((prevData) => ({
        ...prevData,
        [name]: value,
        sToDate: null,
      }));
    } else {
      setOpenSearchData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  const handleCDChange = (name, value) => {
    if (name === "sFromDate") {
      CDMinEndDateTime = value;
      isCDEndDateTimeDisabled = value ? false : true;
      setClosedSearchData((prevData) => ({
        ...prevData,
        [name]: value,
        sToDate: null,
      }));
    } else {
      setClosedSearchData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const openSearchOptions = {
    title: "",
    spacing: 1,
    searchItems: [
      {
        name: "sFromDate",
        label: Strings.TRAN_FROM_DATE,
        type: "datetime",
        minDate: new Date("1900-01-01"),
        defaultValue: openSearchData["sFromDate"],
        onChange: handleODChange,
      },
      {
        name: "sToDate",
        label: Strings.TRAN_TO_DATE,
        type: "datetime",
        isDisable: isODEndDateTimeDisabled,
        minDate: ODMinEndDateTime,
        defaultValue: isODEndDateTimeDisabled
          ? null
          : openSearchData["sToDate"],
        onChange: handleODChange,
      },
      {
        name: "sType",
        label: Strings.TYPE,
        type: "search",
        defaultValue: openSearchData["sType"],
        onChange: handleODChange,
      },
    ],
    handleSearch: handleOpenSearch,
  };
  const closedSearchOptions = {
    title: "",
    spacing: 1,
    searchItems: [
      {
        name: "sFromDate",
        label: Strings.TRAN_FROM_DATE,
        type: "datetime",
        minDate: new Date("1900-01-01"),
        defaultValue: closedSearchData["sFromDate"],
        onChange: handleCDChange,
      },
      {
        name: "sToDate",
        label: Strings.TRAN_TO_DATE,
        type: "datetime",
        isDisable: isCDEndDateTimeDisabled,
        minDate: CDMinEndDateTime,
        defaultValue: isCDEndDateTimeDisabled
          ? null
          : closedSearchData["sToDate"],
        onChange: handleCDChange,
      },
      {
        name: "sType",
        label: Strings.TYPE,
        type: "search",
        defaultValue: closedSearchData["sType"],
        onChange: handleCDChange,
      },
    ],
    handleSearch: handleClosedSearch,
  };

  const cardDetailsCTAs = [
    {
      title: Strings.SUSPEND,
      action: (type) => {
        CTAButton("SUSPEND", type);
      },
    },
    {
      title: Strings.UNSUSPEND,
      action: (type) => {
        CTAButton("UNSUSPEND", type);
      },
    },
  ];

  const CTAButton = (btnType, balanceType) => {
    let type = "status";
    let urlName = cardholdersEndPoints.changeStatusOfCard;
    let params = {
      Type: balanceType.id,
      CardStatusId: btnType === "SUSPEND" ? 2 : 1,
      Reason: Strings.CARD_STATUS_CHANGE_REASON,
    };
    const url = format(urlName, cardId, type);
    axios
      .put(url, params, {
        headers: { Authorization: authToken },
      })
      .then((res) => {
        setStatusAPIRes({
          success: res.data.success,
          message:
            res.data.success === true
              ? Strings.CARD_STATUS_CHANGE_SUCCESS
              : res.data.errors?.message ?? Strings.CARD_STATUS_CHANGE_FAIL,
        });
        setSnackOpen(true);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setIsLoading(false));
  };

  //#region cardTabDetails
  const cardTabDetails = [
    {
      index: 0,
      type: { name: "Open", id: 1 },
      title: "",
      tab_title: Strings.OL_CURRENT_BALANCE_TITLE,
      cardImage: Strings.IMG_MASTER_CARD_LOGO,
      backgroundImage: cardInfo?.backgroundImageUrl,
      balance: openBalance.openBalance,
      balanceDate: openBalance.openBalanceLastUpdatedDate,
      actions: cardDetailsCTAs
    },
    {
      index: 1,
      type: { name: "Closed", id: 2 },
      title: "",
      tab_title: Strings.CL_CURRENT_BALANCE_TITLE,
      cardImage: Strings.IMG_CASINO_LOGO_SMALL,
      backgroundImage: cardInfo?.backgroundImageUrl,
      balance: closedBalance.closedBalance,
      balanceDate: closedBalance.closedBalanceLastUpdatedDate,
      actions: cardDetailsCTAs
    },
  ];
  //#endregion
  let defaultAddress = [],
    defaultPhone = [],
    defaultEmail = [];
  const getDetails = async() => {

    setDetailsLoading(true)

    try {
      await addressGrid();
      await PhoneGrid();
      await emailGrid();
      
      const url = format(cardholdersEndPoints.getCardHolderByID, id);
      const res = await axios
        .get(url, {
          headers: { Authorization: authToken },
        })
      
      if(res.data.success){
        const result = res.data.data;
        const phone = defaultPhone;
        const emails = defaultEmail;
        let address = defaultAddress;
        let addrVal = [
          address?.colony ?? "",
          address?.street ?? "",
          address?.betweenStreets ?? "",
          address?.city ?? "",
          address?.state ?? "",
          address?.country ?? "",
          address?.zipCode ?? "",
        ]
        .filter((item) => item && true)
        .join(", ");

        setDetails({
          fullname:
            result.firstName +
            " " +
            (result.middleName ? result.middleName + " " : "") +
            result.lastName,
          telephone: phone?.phoneNumber,
          email: emails?.emailValue,
          address: addrVal ?? "",
          dob: new Date(result.dateOfBirth).toLocaleDateString("en-us"),
          driversLicense: "",
        });
        const cardVal = [
          { cardHolderType: "Baley's" },
          { cardHolderType: "Strip" },
          { cardHolderType: "Other Programs" },
        ];
        setCardType(cardVal);
        cardId == 0 && setCardId(result.idCard);
      }
    } catch (error) {
      console.log(error)
    } 
    setDetailsLoading(false)
    
  };

  const getLastStartup = async() => {
    const url = format(cardholdersEndPoints.getLastStartup, id);
    const res = await axios
      .get(url, {
        headers: { Authorization: authToken },
      })
    if (res.data.success) {
      const result = res.data.data;
      setDeviceLog(result)
    }
  };

  const setActiveCardRealDetail = () => {
    const { program, idGroup, idMerchant } =
      allCardData && allCardData.find((a) => a.idCard == cardId);
    const currentIndex = allCardData.findIndex((a) => a.idCard == cardId);
    setCardRealIndex(currentIndex);
    setCardProgramDescription(program);
    getGroupDetailById(idGroup);
    getMerchentDetailById(idGroup, idMerchant);
    onRealChange() // call this function to update top box 
  };

  const getOpenCardBalance = () => {
    setIsLoading(true);

    const url = format(cardholdersEndPoints.getOpenBalanceByCardId, cardId);
    axios
      .get(url, {
        headers: { Authorization: authToken },
      })
      .then((res) => {
        if (res.data.success) {
          const result = res.data.data;
          const { balance, currencyCode } = result;

          setOpenBalance({
            openBalance: "$" + balance,
            openBalanceLastUpdatedDate: "Last updated 05/15/21",
            openCurrencyCode: currencyCode,
          });
        } else {
          setOpenBalance([]);
        }
      })
      .catch((err) => err)
      .finally(() => setIsLoading(false));
  };

  const getClosedCardBalance = () => {
    setIsLoading(true);
    const url = format(cardholdersEndPoints.getClosedBalanceByCardId, cardId);
    axios
      .get(url, {
        headers: { Authorization: authToken },
      })
      .then((res) => {
        if (res.data.success) {
          const result = res.data.data;
          const { balance, currencyCode } = result;

          setClosedBalance({
            closedBalance: "$" + balance,
            closedBalanceLastUpdatedDate: "Last updated 05/16/21",
            closedCurrencyCode: currencyCode,
          });
        }
      })
      .catch((err) => err)
      .finally(() => setIsLoading(false));
  };

  //#region Transactions
  // type => 0(Open), 1(Close)
  const getTransactionsData = (query, type) =>
    new Promise((resolve, reject) => {
      let offset = query.page === 0 ? query.page : query.page * query.pageSize;
      let pageSize = query.pageSize;

      let fromDate = query.fromDate ?? firstDateNTime;
      let toDate = query.toDate ?? lastDateNTime;
      let transTypes = query.transTypes ?? "";

      let url = format(
        cardholdersEndPoints.getCardholderOpenLoopTransaction,
        offset,
        pageSize,
        fromDate,
        toDate
      );

      let params = {
        transTypes: transTypes,
        affectsOpenLoop: type === 1 ? 1 : 0,
        onlyGatherOpenLoopAffectationsInDetails: type === 1 ? true : false,
        affectsCloseLoop: type === 0 ? 1 : 0,
        onlyGatherCloseLoopAffectationsInDetails: type === 0 ? true : false,
        idCardholder: id,
      };

      axios
        .get(url, {
          headers: { Authorization: authToken },
          params: params,
        })
        .then((res) => {
          if (res.data.success) {
            const { registries, totalRegistries } = res.data.data;

            resolve({
              data: type === 0 ? registries : [], //Flexia Portal Comments July 19 2021.docx
              page: query.page,
              totalCount: totalRegistries,
            });
          }
        });
    });

  const detailPanelOpenBalance = [
    {
      tooltip: "view details",
      render: (rowData) => {
        return (
          <Box p={1.5} style={{ backgroundColor: "#d8d8d8" }}>
            <Paper elevation={0}>
              <MaterialTable
                columns={transcationColumnsOBInner}
                data={rowData.childTransactions}
                isLoading={isLoading}
                options={{
                  ...transStylingOption,
                  pageSize: 5,
                  pageSizeOptions: [5],
                }}
              />
            </Paper>
          </Box>
        );
      },
    },
  ];
  const detailPanelClosedBalance = [
    {
      tooltip: "view details",
      render: (rowData) => {
        return (
          <Box p={1.5} style={{ backgroundColor: "#d8d8d8" }}>
            <Paper elevation={0}>
              <MaterialTable
                columns={transcationColumnsCBInner}
                data={rowData.childTransactions}
                isLoading={isLoading}
                options={{
                  ...transStylingOption,
                  pageSize: 5,
                  pageSizeOptions: [5],
                }}
              />
            </Paper>
          </Box>
        );
      },
    },
  ];
  const prevTransactions = [
    {
      title: "",
      tab_title: "OpenBalance",
      type: 0,
      index: 0,
      cardImage: Strings.IMG_CASINO_LOGO_SMALL,
      cardName: "FLEXIA TRANSACTIONS",
      //lastUpdated: "Last updated MM/DD/YY",
      lastUpdated: "",
      columns: transcationOpenColumns,
      getData: getTransactionsData,
      detailPanel: detailPanelOpenBalance,
      searchOption: openSearchOptions,
      tableRef: tableRefOpen,
    },
    {
      title: "",
      tab_title: "ClosedBalance",
      type: 1,
      index: 1,
      cardImage: Strings.IMG_MASTER_CARD_LOGO,
      cardName: "EXTERNAL TRANSACTIONS",
      //lastUpdated: "Last updated MM/DD/YY",
      lastUpdated: "",
      columns: transcationCloseColumns,
      getData: getTransactionsData,
      detailPanel: detailPanelClosedBalance,
      searchOption: closedSearchOptions,
      tableRef: tableRefClosed,
    },
  ];

  //#endregion

  const addressEditOptions = {
    onRowAdd: (newData) =>
      new Promise((resolve) => {
        const url = format(cardholdersEndPoints.addCardholderAddress, id);
        axios
          .post(url, newData, { headers: { Authorization: authToken } })
          .then((res) => {
            if (res.data.success) {
              setAddressData((prevData) => [...prevData, newData]);
              resolve();
            }
          });
      }),
    onRowUpdate: (newData, oldData) =>
      new Promise((resolve) => {
        const url = format(
          cardholdersEndPoints.updateCardholderAddress,
          id,
          newData.idAddress
        );
        axios
          .put(url, newData, { headers: { Authorization: authToken } })
          .then((res) => {
            if (res.data.success) {
              const index = oldData.tableData.id;
              setAddressData((prevData) =>
                prevData.map((item, ix) => (ix === index ? newData : item))
              );
              resolve();
            }
          });
      }),
  };

  const telEditOptions = {
    onRowAdd: (newData) =>
      new Promise((resolve) => {
        const url = format(cardholdersEndPoints.addCardholderPhone, id);
        axios
          .post(url, newData, { headers: { Authorization: authToken } })
          .then((res) => {
            if (res.data.success) {
              setTelephoneData((prevData) => [...prevData, newData]);
              resolve();
            }
          });
      }),
    onRowUpdate: (newData, oldData) =>
      new Promise((resolve) => {
        const url = format(
          cardholdersEndPoints.updateCardholderPhone,
          id,
          newData.idPhone
        );
        axios
          .put(url, newData, { headers: { Authorization: authToken } })
          .then((res) => {
            if (res.data.success) {
              const index = oldData.tableData.id;
              setTelephoneData((prevData) =>
                prevData.map((item, ix) => (ix === index ? newData : item))
              );
              resolve();
            }
          });
      }),
  };

  const mailEditOptions = {
    onRowAdd: (newData) =>
      new Promise((resolve) => {
        const url = format(cardholdersEndPoints.addCardholderEmail, id);
        axios
          .post(url, newData, { headers: { Authorization: authToken } })
          .then((res) => {
            if (res.data.success) {
              setEmailData((prevData) => [...prevData, newData]);
              resolve();
            }
          });
      }),
    onRowUpdate: (newData, oldData) =>
      new Promise((resolve) => {
        const url = format(
          cardholdersEndPoints.updateCardholderEmail,
          id,
          newData.idEmail
        );
        axios
          .put(url, newData, { headers: { Authorization: authToken } })
          .then((res) => {
            if (res.data.success) {
              const index = oldData.tableData.id;
              setEmailData((prevData) =>
                prevData.map((item, ix) => (ix === index ? newData : item))
              );
              resolve();
            }
          });
      }),
  };
  const handleModalClose = () => {
    setOpenDialog(false);
  };

  const addressGrid = async() => {
    const url = format(cardholdersEndPoints.getCardholderAddressById, id);
    const res = await axios
      .get(url, {
        headers: { Authorization: authToken },
      })
    if (res.data.success) {
      const result = res.data.data;
      setAddressData(result ?? []);
      defaultAddress = result?.filter((addr) => addr.preferred === true)[0];
    }
  };
  const PhoneGrid = async() => {
    const url = format(cardholdersEndPoints.getCardholderPhoneById, id);
    const res = await axios
      .get(url, {
        headers: { Authorization: authToken },
      })
    if (res.data.success) {
      const result = res.data.data;
      setTelephoneData(result ?? []);
      defaultPhone = result?.filter((ph) => ph.preferred === true)[0];
    }
  };
  const emailGrid = async() => {
    const url = format(cardholdersEndPoints.getCardholderEmailById, id);
    const res = await axios
      .get(url, {
        headers: { Authorization: authToken },
      })
    if (res.data.success) {
      const result = res.data.data;
      setEmailData(result ?? []);
      defaultEmail = result?.filter((e) => e.preferred === true)[0];
    }
  };
  const handleActionClick = () => {
    addressGrid();
    PhoneGrid();
    emailGrid();
    setModalHeader({
      isForm: true,
      title: "Profile Details",
      modalWidth: "md",
    });
    setModalContent({
      address: {
        label: "Addresses",
        type: "table",
        col: 12,
        columns: addressCols,
        editable: addressEditOptions,
        data: addressData,
      },
      telephones: {
        label: "Telephones",
        type: "table",
        col: 12,
        columns: teleCols,
        editable: telEditOptions,
        data: telephoneData,
      },
      emails: {
        label: "Emails",
        type: "table",
        col: 12,
        columns: emailCols,
        editable: mailEditOptions,
        data: emailData,
      },
    });
    setOpenDialog(true);
  };

  const onRealChange = (index, active) => {
    const { idCard, program, idGroup, idMerchant, lastEightDigits } = allCardData[index];
    setCardRealIndex(index);
    setCardId(idCard);
    setCardProgramDescription(program);
    //setCardNumberDescription(lastEightDigits)
    getGroupDetailById(idGroup);
    getMerchentDetailById(idGroup, idMerchant);
  };
  const getGroupDetailById = (idGroup) => {
    new Promise((resolve, reject) => {
      const url = format(groupsEndPoints.getGroupById, idGroup);
      axios
        .get(url, {
          headers: { Authorization: authToken },
        })
        .then((res) => {
          if (res.data.success) {
            const result = res.data.data;
            const { description } = result;
            setCardGroupDescription(description);
            resolve(res.data);
          }
        })
        .catch((err) => err);
    });
  };
  const getMerchentDetailById = (idGroup, idMerchant) => {
    new Promise((resolve) => {
      let url = format(
        merchantsEndPoints.getMerchantByMerchantId,
        idGroup,
        idMerchant
      );
      axios
        .get(url, { headers: { Authorization: authToken } })
        .then((res) => {
          if (res.status === 200) {
            const { data } = res.data;
            const { merchant } = data;
            const { description } = merchant;
            setCardMerchantDescription(description);
            resolve(data);
          }
        })
        .catch((err) => err)
        .finally(() => setIsLoading(false));
    });
  };
  const getCardInfoByCardId = () => {
    let url = format(cardholdersEndPoints.getCardInfoByCardId, cardId);
    axios
      .get(url, { headers: { Authorization: authToken } })
      .then((res) => {
        if (res.status === 200) {
          const { data } = res.data;
          //console.log(data)
          setCardInfo(data);
        }
      })
      .catch((err) => err)
      .finally(() => setIsLoading(false));
  };
  return {
    details,
    isLoading,
    detailsLoading, 
    balanceLoading,
    generalLoading,
    cardBasicDetails,
    openDialog,
    handleModalClose,
    modalHeader,
    modalContent,
    modalFormResetKeys,
    handleActionClick,
    cardTabDetails,
    value,
    setValue,
    TranscationTabIndex,
    setTranscationTabIndex,
    prevTransactions,
    cardHolderPermission,
    statusAPIres,
    snak_open,
    setSnackOpen,
    allCardData,
    onRealChange,
    realDetails,
    cardRealIndex,
    config,
    device_log,
    cardInfo
  };
}

export default useCardholdersDetails;
